import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import axios from 'axios'
import service from './api'
import config from './config'
import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import 'videojs-contrib-hls'

Vue.use(VideoPlayer)
Vue.use(ElementUI)
Vue.prototype.$axios = axios
Vue.prototype.$api = service
Vue.prototype.$config = config
Vue.config.productionTip = false

document.title = config.title

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
